import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { HttpApiService } from '@recruitee/http';
import type { InvoiceDownloadURL, InvoiceResourceType } from '@recruitee/invoices-types';

@Injectable({ providedIn: 'root' })
export class InvoiceDownloadUrlService {
  constructor(protected httpApi: HttpApiService) {}

  public get(invoiceId: string, resourceType: InvoiceResourceType): Observable<InvoiceDownloadURL> {
    return this.httpApi.get<InvoiceDownloadURL>(`/invoices/${invoiceId}/pdf`, {
      resource_type: resourceType,
    });
  }
}
